export class ApiError<T> extends Error {
  public Status: number;
  public Data?: T;

  constructor(message: string, status: number, data?: T) {
    super(message);
    this.name = "ApiError";
    this.Status = status;
    this.Data = data;
  }
}

export interface RequestOptions extends RequestInit {
  skipAuth?: boolean;
}
